<template>
  <BaseToast
    stripeColor="var(--color-yellow)"
    icon="fas fa-exclamation-triangle"
    iconColor="var(--color-yellow-dark)"
    :title="title || 'Advertencia'"
    @close="$emit('close')"
  >
    <slot />
  </BaseToast>
</template>

<script setup lang="ts">
  import BaseToast from './BaseToast.vue';

  defineProps<{
    title?: string;
  }>();

  defineEmits<{
    close: [];
  }>();
</script>

<style scoped lang="scss">
  @use '@/app/assets/sass/variables' as *;

  :deep(.base-toast-icon) {
    background: var(--color-orange-lightest);
  }

  :deep(.base-toast-icon .fas) {
    color: var(--color-yellow-dark);
  }
</style>
